<!-- <div *ngIf="!article?.isActive" class="sold-out">
<ion-icon src="../../../assets/topgolf/sold_out.svg"></ion-icon>
</div> -->

<ion-row
	(click)="addToBasketCustomize(article); $event.preventDefault(); $event.stopPropagation()"
	[class.inactive]="!article?.isActive"
	[class.isAdded]="checkQuantityIfHasInBasket > 0"
	aria-setsize="12"
	class="item-row pointer"
>
	<div class="discount-badges">
		@for (discount of consumerDisplayDiscounts(repositoryService, article); track $index) {
			<app-double-monday-component [label]="discount.consumerDisplayname"></app-double-monday-component>
		}
	</div>
	@if (checkQuantityIfHasInBasket) {
		<div class="amount-in-basket">
			<ion-icon class="checkmark" src="../../../assets/topgolf/selected.svg"></ion-icon>
		</div>
	}

	<ion-col class="ion-no-padding item-col">
		<!-- <div class="new" *ngIf="showMostWanted">{{ 'common.new' | translate }}!</div> -->
		<div [class.block-adding]="!canBeAdded" class="img-wrapper">
			@if (!canBeAdded) {
				<ion-icon src="../../../assets/topgolf/lock.svg"></ion-icon>
			}
			@if (article.assets.large) {
				<ion-img [src]="article.assets.large" class="item-image cover-image"></ion-img>
			}
			@if (!article.assets.medium) {
				<ion-icon class="item-image default-image" src="../../../assets/topgolf/header_logo.svg"></ion-icon>
			}
		</div>

		<h3 class="item-name">
			{{ article.name | langObservable | async }}
		</h3>

		@if (article.shortDescription) {
			<p class="item-info">
				{{ article.shortDescription | langObservable | async }}
			</p>
		}

		<div class="price-row">
			@if (findFeatureArray.length > 0) {
				<div class="tags">
					@for (tagsIcon of findFeatureArray; track tagsIcon) {
						<ion-icon [src]="'../../../assets/tags/' + tagsIcon + '.svg'"></ion-icon>
					}
				</div>
			}

			@if (findFeatureArray.length > 0) {
				<div class="divider"></div>
			}

			@if (!isLoyalty) {
				<p class="price">
					{{ getDisplayPriceText() }}
				</p>
			}
		</div>

		@if (!isLoyalty && article?.isActive) {
			<div class="buttons">
				@if (checkQuantityIfHasInBasket === 0 || articleNeedsCustomization(article)) {
					<ion-icon
						(click)="addToBasketCustomize(article); $event.preventDefault(); $event.stopPropagation()"
						class="add-button-icon"
						src="../../../assets/topgolf/add-button.svg"
					>
					</ion-icon>
				}
				@if (checkQuantityIfHasInBasket > 0 && !articleNeedsCustomization(article)) {
					<div (click)="$event.preventDefault(); $event.stopPropagation()" class="quantity-selector">
						<div
							(click)="decreaseQuantity(article); $event.preventDefault(); $event.stopPropagation()"
							class="quantity-btn-wrapper"
						>
							<ion-icon class="quantity-btn" src="../../../assets/icon/minus.svg"></ion-icon>
						</div>
						<span class="quantity-text">{{ checkQuantityIfHasInBasket }}</span>
						<div
							(click)="increaseQuantity(article); $event.preventDefault(); $event.stopPropagation()"
							class="quantity-btn-wrapper"
						>
							<ion-icon class="quantity-btn" src="../../../assets/icon/plus.svg"></ion-icon>
						</div>
					</div>
				}
			</div>
		}

		@if (isLoyalty) {
			<div class="buttons">
				@if (amountOfPoints >= article?.piggyReward?.required_credits) {
					<ion-button (click)="addLoyaltyItem(article); $event.preventDefault(); $event.stopPropagation()" class="add-button"
						>{{ 'item_view.get_reward' | translate }}
					</ion-button>
				}
				@if (amountOfPoints < article?.piggyReward?.required_credits) {
					<ion-button class="add-button not-enought"> {{ 'item_view.get_reward' | translate }}</ion-button>
				}
			</div>
		}
		@if (!canBeAdded) {
			<ion-progress-bar [value]="valueOfSlider < 1 ? valueOfSlider : 1" class="progress-bar"></ion-progress-bar>
		}
	</ion-col>
</ion-row>
